import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { editStatePaymentRemittanceType } from "../atoms/atoms";
import { PaymentRemittanceTypeInfo } from "../types";

export default function PaymentRemittanceTypeDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: PaymentRemittanceTypeInfo | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStatePaymentRemittanceType);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.paymentRemittanceTypeName);
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.status);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-5 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-3 my-1">
              <TextInputLabelHookForm
                name="paymentRemittanceTypeName"
                label="Payment Remittance Type Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);
                  if (
                    e.target.value.length === 0 ||
                    (e.target.value === data?.paymentRemittanceTypeName &&
                      checkBoxChanges === data?.status)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                required={true}
                className={
                  formMethods.formState.errors.paymentRemittanceTypeName &&
                  formMethods.formState.errors.paymentRemittanceTypeName
                    .message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("paymentRemittanceTypeName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="status"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.length === 0 ||
                      (e.target.checked === data?.status &&
                        inputData === data?.paymentRemittanceTypeName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  className={
                    formMethods.formState.errors.status &&
                    formMethods.formState.errors.status.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
